/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { ProductDeliveryStockItemList } from '../../models/product-delivery-stock-item-list';

export interface DeliveryControllerFindProductInDelivery$Params {
  order_id: number;
  delivery_id?: number;
}

export function deliveryControllerFindProductInDelivery(http: HttpClient, rootUrl: string, params: DeliveryControllerFindProductInDelivery$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ProductDeliveryStockItemList;
}>> {
  const rb = new RequestBuilder(rootUrl, deliveryControllerFindProductInDelivery.PATH, 'get');
  if (params) {
    rb.query('order_id', params.order_id, {});
    rb.query('delivery_id', params.delivery_id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: ProductDeliveryStockItemList;
      }>;
    })
  );
}

deliveryControllerFindProductInDelivery.PATH = '/delivery/products-in-delivery';
